import { colorConstants } from 'config/colorConstants';

const Bookmark = ({
    color = colorConstants.greyAlt4,
    className = '',
    size = 24,
}: {
    color?: string;
    className?: string;
    size?: number;
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 11 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.83913 2.87528e-07H6.82753C7.36418 -8.21607e-06 7.80709 -1.52091e-05 8.16789 0.029463C8.54262 0.0600798 8.88709 0.125789 9.21064 0.29065C9.71241 0.546312 10.1204 0.954261 10.376 1.45603C10.5409 1.77958 10.6066 2.12405 10.6372 2.49878C10.6667 2.85958 10.6667 3.3025 10.6667 3.83915V12.6667C10.6667 12.9043 10.5402 13.124 10.3346 13.2433C10.1291 13.3626 9.87558 13.3634 9.66924 13.2455L5.33333 10.7678L0.997427 13.2455C0.791091 13.3634 0.537593 13.3626 0.332049 13.2433C0.126506 13.124 6.05419e-07 12.9043 6.05419e-07 12.6667L2.87528e-07 3.83913C-8.21607e-06 3.30249 -1.52091e-05 2.85958 0.029463 2.49878C0.0600798 2.12405 0.125789 1.77958 0.29065 1.45603C0.546312 0.95426 0.95426 0.546312 1.45603 0.29065C1.77958 0.125789 2.12405 0.0600798 2.49878 0.029463C2.85958 -1.52091e-05 3.30249 -8.21607e-06 3.83913 2.87528e-07ZM2.60736 1.35837C2.31508 1.38225 2.16561 1.42553 2.06135 1.47866C1.81046 1.60649 1.60649 1.81046 1.47866 2.06135C1.42553 2.16561 1.38225 2.31508 1.35837 2.60736C1.33385 2.90742 1.33333 3.29561 1.33333 3.86667V11.5179L5.00257 9.42117C5.20753 9.30405 5.45914 9.30405 5.66409 9.42117L9.33333 11.5179V3.86667C9.33333 3.29561 9.33282 2.90742 9.3083 2.60736C9.28442 2.31508 9.24114 2.16561 9.18801 2.06135C9.06018 1.81046 8.8562 1.60649 8.60532 1.47866C8.50106 1.42553 8.35159 1.38225 8.05931 1.35837C7.75925 1.33385 7.37105 1.33333 6.8 1.33333H3.86667C3.29561 1.33333 2.90742 1.33385 2.60736 1.35837Z"
            fill={color}
        />
    </svg>
);

export default Bookmark;
